var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"modal-container has-text-centered"},[_c('div',{},[_c('img',{attrs:{"src":_vm.message},on:{"click":function($event){return _vm.$emit('close')}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }